import axios, { AxiosInstance } from "axios";
import { Configuration } from 'utils/configuration';
// import getConfig from 'next/config';
// const { publicRuntimeConfig } = getConfig();
const config = new Configuration();
const backendUrl = config.GetConfig('API_BASE_URL');

export const apiClient: AxiosInstance = axios.create({
    baseURL: backendUrl,
    timeout: 100000, // Timeout if necessary
    headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${msalAccessToken}`
    },
});